import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { useTranslation } from 'core/i18n/i18n';

export interface BulkEditMaterialComponentProps {
    onClick: VoidFunction;
}

export const BulkEditMaterialComponent: React.FC<BulkEditMaterialComponentProps> = ({ onClick }) => {
    const { t } = useTranslation();

    return (
        <BulkActionButtonComponent
            text={t('settings.materials.material-definitions.bulk-actions.actions.edit')}
            iconName="write"
            onClick={onClick}
        />
    );
};
